"use client";

import Image from "next/image";
import styles from "./sponsor-logos.module.scss";
import Link from "next/link";
import { Col, Row } from "react-bootstrap";

function SponsorLogos() {
  const sponsors = [
    {
      src: "/logos/ai2peat-logo.png",
      text: "AI2Peat Logo",
      url: "https://ai2peat.ie/",
    },
    {
      src: "/logos/ceadar-logo.png",
      text: "CeADAR Logo",
      url: "https://ceadar.ie/",
    },
    {
      src: "/logos/icrag-logo.png",
      text: "ICrag Logo",
      url: "https://www.icrag-centre.org/",
    },
    {
      src: "/logos/research-ireland.png",
      text: "Taighde Éireann - Research Ireland",
      url: "https://www.researchireland.ie/",
    },
    {
      src: "/logos/npws.png",
      text: "NPWS Logo",
      url: "https://www.npws.ie/",
    },
    {
      src: "/logos/eu.png",
      text: "EU Logo",
      url: "https://next-generation-eu.europa.eu",
    },
    {
      src: "/logos/gov-ireland.png",
      text: "Government of Ireland Logo",
      url: "https://www.gov.ie",
    },
    {
      src: "/logos/national-challenge-fund.png",
      text: "National Challenge Fund Logo",
      url: "https://www.sfi.ie/challenges/National-Challenge-Fund/",
    },
  ];
  return (
    <section className={styles.logosContainer}>
      <Row>
        {sponsors.map((sponsor: any, index: number) => (
          <Col
            xs={12}
            sm={6}
            md={4}
            className={`${styles.logoContainer} mb-4`}
            key={index}
          >
            <Link href={sponsor.url} target="_blank">
              <Image
                src={sponsor.src}
                priority
                width="0"
                height="0"
                sizes="100vw"
                alt={sponsor.text}
              />
            </Link>
          </Col>
        ))}
      </Row>
    </section>
  );
}

export default SponsorLogos;
